import { Expose } from 'class-transformer'
import { QuoteParty } from '../../entity'

export class ListQuotePartiesDTO {

    @Expose()
    quoteParties!: QuoteParty[]

}
